module.exports = __webpack_public_path__ + "img/ic_property_semidetachedbungalow.06ef2e90.svg";